import Konva from "konva";

export function getWindowKonvaObject() {
  return (window as unknown as Record<string, unknown>).Konva as typeof Konva;
}
